import {
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction,
  createContext,
  useContext,
  useState
} from 'react';

import { ANYTIME } from 'reservations/availabilities/constants';

type TimePickerSlot = {
  time?: string;
  index: number;
};

interface AvailabilitiesContextInterface {
  timePickerSlots: TimePickerSlot[];
  setTimePickerSlots: Dispatch<SetStateAction<TimePickerSlot[]>>;
  // eslint-disable-next-line unused-imports/no-unused-vars
  handleSetTimePickerSlot: (slots: TimePickerSlot[]) => void;
}

const AvailabilitiesContext =
  createContext<AvailabilitiesContextInterface | null>(null);

const ANYTIME_TIMESLOT = { time: 'Anytime', index: ANYTIME };

export const AvailabilitiesProvider = ({ children }: PropsWithChildren) => {
  const [timePickerSlots, setTimePickerSlots] = useState<TimePickerSlot[]>([
    ANYTIME_TIMESLOT
  ]);

  const handleSetTimePickerSlot = (slots: TimePickerSlot[]) => {
    setTimePickerSlots([ANYTIME_TIMESLOT, ...slots]);
  };

  return (
    <AvailabilitiesContext.Provider
      value={{
        timePickerSlots,
        setTimePickerSlots,
        handleSetTimePickerSlot
      }}
    >
      {children}
    </AvailabilitiesContext.Provider>
  );
};

export function useAvailabilitiesContext() {
  const context = useContext(AvailabilitiesContext);
  if (context == null) {
    throw new Error(
      'useAvailabilitiesContext must be used within Availabilities provider'
    );
  }

  return context;
}
